import React, { Component } from 'react'
import { Typography, Button, Row, Col, Avatar } from 'antd'
import QRScanner from "./QRScanner";
import { LayoutHeaderConfig } from "../MainLayout";
import './Scanner.css'
import routesConfig from "../../routesConfig";

const { Title, Paragraph } = Typography;

export default class ScannerContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            result: undefined,
            error: undefined
        }
    }

    render() {
        console.log("before device enumeration")
        navigator.mediaDevices.enumerateDevices()
            .then(function (devices) {
                devices.forEach(function (device) {
                    if(device.kind==="videoinput") {
                        if(device.label==""){
                            console.log("no camera access yet")
                        } else {
                            console.log("has camera access")
                        }
                    }

                });
            })
            .catch(function (err) {
                console.log(err.name + ": " + err.message);
            });
        // const history = useHistory()
        return (
            <React.Fragment>
                <LayoutHeaderConfig closeable={true} pageTitle="اسکن کد" menuEnabled={false} />
                <React.Fragment>
                    <Row>
                        <Title level={1}>سوار شدن</Title>
                    </Row>
                    <Row justify={'center'}>
                        <Paragraph>لطفا QR کد را پیدا کنید</Paragraph>
                    </Row>
                    <Row>
                        {
                            (this.state.result) ?
                                <Paragraph>{this.state.result}</Paragraph> :
                                (this.state.error) ? <Paragraph>{this.state.error}</Paragraph>
                                    : null
                        }
                    </Row>
                    <div>
                        <QRScanner onDetect={res => {
                            this.setState({ result: res })
                        }} onError={error => {
                            this.setState({ error: "Camera Error" })
                        }} />
                    </div>
                    <Row justify={'center'}>
                        <Button className='button-code' type='primary' shape="round"
                            onClick={event => this.props.history.push(routesConfig.vehicleId)}> کد اسکوتر</Button>
                    </Row>
                </React.Fragment>
            </React.Fragment>)

    }
}
